import { render, staticRenderFns } from "./PdpFeatureTile.vue?vue&type=template&id=bfab4fa4&scoped=true&"
import script from "./PdpFeatureTile.vue?vue&type=script&lang=js&"
export * from "./PdpFeatureTile.vue?vue&type=script&lang=js&"
import style0 from "./PdpFeatureTile.vue?vue&type=style&index=0&id=bfab4fa4&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfab4fa4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconInfoLight: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconInfoLight.vue').default,AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,SvgIconClose: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconClose.vue').default})
